import { GA4Head } from './GA4';
import { GTMHead } from './GTM';
import { HubspotHead } from './Hubspot';
import type { ClientConfig } from '@archipro-website/config';
import { isConfiguredPixelId } from './is-configured-pixel-id';

/**
 * Server-side rendered head pixels. Only essential / shared trackers go here;
 * advertising pixels (Facebook, Pinterest, LinkedIn, Outbrain) live in
 * `ClientAdvertisingPixels` so we can honour Global Privacy Control before
 * loading them.
 */
export const HeadPixels = ({
    gtmId,
    ga4TrackingId,
    hubspotTrackingId,
}: Pick<
    ClientConfig['pixels'],
    'gtmId' | 'ga4TrackingId' | 'hubspotTrackingId'
>) => {
    return (
        <>
            {isConfiguredPixelId(gtmId) && <GTMHead id={gtmId} />}
            {isConfiguredPixelId(ga4TrackingId) && (
                <GA4Head id={ga4TrackingId} />
            )}
            {isConfiguredPixelId(hubspotTrackingId) && (
                <HubspotHead hubspotTrackingId={hubspotTrackingId} />
            )}
        </>
    );
};
